<template>
  <div class="full quotes-app" >
    <TitleBar :portal="portal">
      QuotesApp
    </TitleBar>
    <div class="content-div" @click="$emit('activated')">
      <ul v-if="quotesInfo" class="quotes-list">
        <li :key="qi" v-for="(q, qi) in quotesInfo.data">{{ q.text }} - {{ q.author }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import TitleBar from '../TitleBar'
import nlp from 'compromise'

export default {
  props: {
    portal: {}
  },
  components: {
    TitleBar
  },
  data () {
    return {
      quotesInfo: false
    }
  },
  methods: {
    escapeHtml (text) {
      var encodedStr = text
      var parser = new DOMParser()
      var dom = parser.parseFromString(
        '<!doctype html><body>' + encodedStr,
        'text/html')
      var decodedString = dom.body.textContent
      return decodedString
    }
  },
  mounted () {
    axios.get('/quotes?as=json')
      .then(resp => {
        this.quotesInfo = resp.data
        this.quotesInfo.data.map((item) => {
          item.text = this.escapeHtml(item.text)

          let result = nlp(item.text)
          item.info = item.info || {}
          let info = item.info
          info.adjectives = result.adjectives().out('array')
          info.adverbs = result.adverbs().out('array')
          info.hashTags = result.hashTags().out('array')
          info.nouns = result.nouns().out('array')

          info.all = [
            ...info.adjectives,
            ...info.adverbs,
            ...info.hashTags,
            ...info.nouns
          ]
          console.log(info)
          return item
        })
      })
  }
}
</script>

<style scoped>
@import url(../../../../static/jot.css);

.quotes-app{
  background: linear-gradient(90deg, #4b6cb7 0%, #182848 100%);
  box-sizing: border-box;
  border-radius: 10px 10px 10px 10px;
  color: white;

/* background-image: radial-gradient( circle farthest-corner at 10% 20%,  rgba(149,219,254,1) 0%, rgba(7,134,197,1) 90.1% ); */
}

.content-div{
  height: calc(100% - 30px);
  -webkit-overflow-scrolling: touch;
  overflow: auto;
}

.quotes-list{
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Apps/QuotesApp/index.vue